// src/components/MediaPreview.tsx
'use client';

import React from 'react';

type MediaPreviewProps = {
  src: string;
  showExpanded?: boolean;
  className?: string;
};

export default function MediaPreview({
  src,
  showExpanded = false,
  className = '',
}: MediaPreviewProps) {
  if (!src || typeof src !== 'string') return null;

  const topStyle: React.CSSProperties = {
    backgroundImage: `url("${src}")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center center',
    backgroundSize: 'contain',
    width: '100%',
    height: '100%',
  };

  const bottomStyle: React.CSSProperties = {
    backgroundImage: `url("${src}")`,
    backgroundRepeat: 'no-repeat',
    backgroundPosition: 'center bottom',
    backgroundSize: 'cover',
    transform: 'scale(1.06)',
    filter: 'blur(18px)',
    width: '100%',
    height: '88%',
    position: 'absolute',
    left: 0,
    right: 0,
    bottom: 0,
  };

  return (
    <div
      className={`media-hero ${showExpanded ? 'media-hero--expanded' : ''} ${className}`}
      aria-hidden="true"
      style={{
        position: 'relative',
        width: '100%',
        height: showExpanded ? '100%' : 320,
        borderRadius: showExpanded ? 0 : 24,
        overflow: 'hidden',
      }}
    >
      <div className="media-top" style={topStyle} />
      <div className="media-bottom" style={bottomStyle}>
        <div
          style={{
            position: 'absolute',
            inset: 0,
            background: 'linear-gradient(to top, rgba(0,0,0,0.45), rgba(0,0,0,0))',
            pointerEvents: 'none',
          }}
        />
      </div>
    </div>
  );
}
